/* eslint-disable babel/camelcase */
import { ENV } from '@/config'

export type IntercomSettings = {
  app_id: string
  intercom_user_jwt: string
  hide_default_launcher: boolean
}

export const getIntercomAppId = (isProd = ENV === 'production'): string => (
  isProd ? 'quse8o11' : 'm9jgpgp3'
)

export const getIntercomSettings = (intercomUserJwt: string): IntercomSettings => ({
  app_id: getIntercomAppId(),
  intercom_user_jwt: intercomUserJwt,
  hide_default_launcher: true,
})
